import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "fill-height pa-2" }
const _hoisted_2 = { class: "inline-icon" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"text-align":"center","width":"100%"} }
const _hoisted_5 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%"} }
const _hoisted_6 = ["viewBox"]
const _hoisted_7 = ["xlink:href", "height", "width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_SelectUser = _resolveComponent("SelectUser")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_company_table = _resolveComponent("company-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_layout, { wrap: "" }, {
      default: _withCtx(() => [
        _cache[56] || (_cache[56] = _createElementVNode("h2", null, "Valider le justificatif", -1)),
        _createVNode(_component_v_flex, {
          xs12: "",
          sm7: "",
          style: {"display":"flex"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_switch, {
              modelValue: _ctx.showDocument,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showDocument) = $event)),
              "hide-details": "",
              label: "Afficher le document",
              class: "my-0 py-1"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_window, {
      modelValue: _ctx.step,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.step) = $event)),
      horizontal: "",
      class: "fill-height"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "default_card_mobile",
              style: {"background-color":"transparent"},
              elevation: "0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.wizardStepTitle), 1),
                    _createVNode(_component_v_avatar, {
                      color: "primary lighten-2",
                      class: "subheading white--text",
                      size: "24",
                      textContent: _toDisplayString(_ctx.wizardStep)
                    }, null, 8, ["textContent"])
                  ]),
                  _: 1
                }),
                (_ctx.form.date)
                  ? (_openBlock(), _createBlock(_component_v_window, {
                      key: 0,
                      modelValue: _ctx.wizardStep,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.wizardStep) = $event)),
                      style: {"min-height":"27vh"},
                      touchless: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window_item, { value: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "py-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentTypeItems, (type, i) => {
                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: i,
                                        class: _normalizeClass(_ctx.geDocumentTypeClass(type.type)),
                                        onClick: _withModifiers(($event: any) => (_ctx.document.type = type.type), ["stop"])
                                      }, {
                                        prepend: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            class: _normalizeClass(type.iconClass)
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(type.icon), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["class"])
                                        ]),
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_btn, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.document.type === type.type
                                                        ? "$radio_button_checked"
                                                        : "$radio_button_unchecked"), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(type.title), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "onClick"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "py-0" }, {
                              default: _withCtx(() => [
                                (_ctx.wizardStep === 8)
                                  ? (_openBlock(), _createBlock(_component_SelectUser, {
                                      key: 0,
                                      companyId: _ctx.companyId,
                                      selectedUser: _ctx.currentAccountUser,
                                      onUserSelected: _ctx.onUserSelected
                                    }, null, 8, ["companyId", "selectedUser", "onUserSelected"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { justify: "space-around" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_radio_group, {
                                      modelValue: _ctx.document.creditNote,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.creditNote) = $event)),
                                      color: "primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_radio, {
                                          label: "Non",
                                          value: false
                                        }),
                                        _createVNode(_component_v_radio, {
                                          label: "Oui",
                                          value: true
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 3 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { style: {"padding-top":"0"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_flex, { class: "text-center mb-2" }, {
                                  default: _withCtx(() => [
                                    (_ctx.document.thirdPartyCompany)
                                      ? (_openBlock(), _createBlock(_component_v_card, {
                                          key: 0,
                                          class: "default_card_wm mx-auto",
                                          style: {"background":"#fff !important","box-shadow":"none"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card_title, {
                                              "primary-title": "",
                                              class: "py-0"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.document.thirdPartyCompany
                                                        ? _ctx.document.thirdPartyCompany.name
                                                        : ""), 1)
                                              ]),
                                              _: 1
                                            }),
                                            (!_ctx.consumer)
                                              ? (_openBlock(), _createBlock(_component_v_card_text, {
                                                  key: 0,
                                                  class: "text-left pb-0"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Siret : " + _toDisplayString(_ctx.getSiretValue(_ctx.document.thirdPartyCompany.siret)), 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                (_ctx.document.type === 'SALES_INVOICE' && !_ctx.consumer)
                                  ? (_openBlock(), _createBlock(_component_v_flex, {
                                      key: 0,
                                      class: "text-center mb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.consumer = true)),
                                          class: "btn",
                                          rounded: "",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[57] || (_cache[57] = [
                                            _createTextVNode(" Le client est un particulier ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_flex, { class: "text-center mb-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogSelectCompany = true)),
                                      class: "btn",
                                      rounded: "",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.otherThirdPartyCompany), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 9 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "py-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_combobox_filled, {
                                  items: _ctx.invoiceNumberList,
                                  color: _ctx.form.invoiceNumber.validated ? 'green' : 'red',
                                  rules: [_ctx.form.invoiceNumber.validated || ''],
                                  success: _ctx.form.invoiceNumber.validated,
                                  error: !_ctx.form.invoiceNumber.validated,
                                  "append-outer-icon": 
                                        _ctx.form.invoiceNumber.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    ,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (
                                        _ctx.onDateChange(_ctx.form.invoiceNumber, 'invoiceNumber', $event)
                                    )),
                                  onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (
                                        _ctx.onDateChange(_ctx.form.invoiceNumber, 'invoiceNumber', $event)
                                    ), ["enter"])),
                                  "onClick:appendOuter": _cache[6] || (_cache[6] = ($event: any) => (
                                        _ctx.form.invoiceNumber.validated = !_ctx.form.invoiceNumber.validated
                                    )),
                                  onMouseover: _cache[7] || (_cache[7] = ($event: any) => (_ctx.highlightField(_ctx.form.invoiceNumber, true))),
                                  onMouseout: _cache[8] || (_cache[8] = ($event: any) => (_ctx.highlightField(_ctx.form.invoiceNumber, false))),
                                  outlined: "",
                                  "hide-details": true,
                                  "model-value": _ctx.form.invoiceNumber.value
                                }, null, 8, ["items", "color", "rules", "success", "error", "append-outer-icon", "model-value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 4 }, {
                          default: _withCtx(() => [
                            (_ctx.form.date)
                              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_combobox_filled, {
                                      items: _ctx.dateList,
                                      rules: _ctx.dateRules,
                                      "prepend-inner-icon": '$vuetify.icons.calendar',
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.onDateChange(_ctx.form['date'], 'date', $event))),
                                      onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.onDateChange(_ctx.form['date'], 'date', $event)), ["enter"])),
                                      "onClick:prependInner": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dateDialog = !_ctx.dateDialog)),
                                      onMouseover: _cache[12] || (_cache[12] = ($event: any) => (_ctx.highlightField(_ctx.form['date'], true))),
                                      onMouseout: _cache[13] || (_cache[13] = ($event: any) => (_ctx.highlightField(_ctx.form['date'], false))),
                                      outlined: "",
                                      required: "",
                                      dense: "",
                                      "model-value": _ctx.formatObjectDate(_ctx.form.date)
                                    }, null, 8, ["items", "rules", "model-value"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 5 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_date_picker_wrapper, {
                                  locale: "fr-FR",
                                  modelValue: _ctx.dueDate,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dueDate) = $event)),
                                  "full-width": "",
                                  landscape: !_ctx.$vuetify.display.mobile,
                                  class: "elevation-0",
                                  color: "secondary",
                                  scrollable: ""
                                }, null, 8, ["modelValue", "landscape"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 6 }, {
                          default: _withCtx(() => [
                            (_ctx.form && _ctx.form.single_prices && _ctx.form.subAmounts)
                              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                                  default: _withCtx(() => [
                                    (_ctx.subjectToVAT)
                                      ? (_openBlock(), _createBlock(_component_v_flex, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                              _createVNode(_component_v_flex, {
                                                xs11: "",
                                                class: "pa-0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_switch, {
                                                    modelValue: _ctx.multiVat,
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.multiVat) = $event)),
                                                    label: "Multi TVA",
                                                    "hide-details": "",
                                                    disabled: _ctx.disabledMultiVat,
                                                    class: "my-0 pl-2"
                                                  }, null, 8, ["modelValue", "disabled"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "pr-1 pb-1"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_oss_text_field, {
                                                      "onUpdate:modelValue": [
                                                        _cache[16] || (_cache[16] = ($event: any) => (
                                                    _ctx.onMetadataChange(
                                                        _ctx.form.single_prices.prices,
                                                        '',
                                                        'netAmount',
                                                    )
                                                )),
                                                        _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.single_prices.prices.netAmount.value) = $event))
                                                      ],
                                                      onMouseover: _cache[17] || (_cache[17] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.netAmount,
                                                        true,
                                                    )
                                                )),
                                                      onMouseout: _cache[18] || (_cache[18] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.netAmount,
                                                        false,
                                                    )
                                                )),
                                                      color: 
                                                    _ctx.priceTextColor_amountData(
                                                        _ctx.form.single_prices.prices,
                                                        true,
                                                    )
                                                ,
                                                      rules: [_ctx.form.allPricesValidated || ''],
                                                      readonly: _ctx.multiVat,
                                                      regular: "",
                                                      "content-class": "oss-",
                                                      "hide-details": true,
                                                      modelValue: _ctx.form.single_prices.prices.netAmount.value
                                                    }, {
                                                      label: _withCtx(() => _cache[58] || (_cache[58] = [
                                                        _createTextVNode(" HT ")
                                                      ])),
                                                      _: 1
                                                    }, 8, ["color", "rules", "readonly", "modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "pb-1"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_oss_text_field, {
                                                      "onUpdate:modelValue": [
                                                        _cache[20] || (_cache[20] = ($event: any) => (
                                                    _ctx.onMetadataChange(
                                                        _ctx.form.single_prices.prices,
                                                        '',
                                                        'grossAmount',
                                                    )
                                                )),
                                                        _cache[23] || (_cache[23] = ($event: any) => ((
                                                    _ctx.form.single_prices.prices.grossAmount.value
                                                ) = $event))
                                                      ],
                                                      onMouseover: _cache[21] || (_cache[21] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.grossAmount,
                                                        true,
                                                    )
                                                )),
                                                      onMouseout: _cache[22] || (_cache[22] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.grossAmount,
                                                        false,
                                                    )
                                                )),
                                                      color: 
                                                    _ctx.priceTextColor_amountData(
                                                        _ctx.form.single_prices.prices,
                                                        true,
                                                    )
                                                ,
                                                      rules: [_ctx.form.allPricesValidated || ''],
                                                      readonly: _ctx.multiVat,
                                                      regular: "",
                                                      "content-class": "mr-1 oss-",
                                                      "hide-details": true,
                                                      modelValue: 
                                                    _ctx.form.single_prices.prices.grossAmount.value
                                                
                                                    }, {
                                                      label: _withCtx(() => _cache[59] || (_cache[59] = [
                                                        _createTextVNode(" TTC ")
                                                      ])),
                                                      _: 1
                                                    }, 8, ["color", "rules", "readonly", "modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "pr-1 pb-1"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_oss_text_field, {
                                                      "onUpdate:modelValue": [
                                                        _cache[24] || (_cache[24] = ($event: any) => (
                                                    _ctx.onMetadataChange(
                                                        _ctx.form.single_prices.prices,
                                                        '',
                                                        'vatAmount',
                                                    )
                                                )),
                                                        _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.single_prices.prices.vatAmount.value) = $event))
                                                      ],
                                                      onMouseover: _cache[25] || (_cache[25] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.vatAmount,
                                                        true,
                                                    )
                                                )),
                                                      onMouseout: _cache[26] || (_cache[26] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.vatAmount,
                                                        false,
                                                    )
                                                )),
                                                      color: 
                                                    _ctx.priceTextColor_amountData(
                                                        _ctx.form.single_prices.prices,
                                                        true,
                                                    )
                                                ,
                                                      rules: [_ctx.form.allPricesValidated || ''],
                                                      readonly: _ctx.multiVat,
                                                      regular: "",
                                                      "content-class": "mr-1 oss-",
                                                      "hide-details": true,
                                                      modelValue: _ctx.form.single_prices.prices.vatAmount.value
                                                    }, {
                                                      label: _withCtx(() => _cache[60] || (_cache[60] = [
                                                        _createTextVNode(" TVA ")
                                                      ])),
                                                      _: 1
                                                    }, 8, ["color", "rules", "readonly", "modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "pr-1 pb-1"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _withDirectives(_createVNode(_component_v_select_filled, {
                                                      items: _ctx.vatList,
                                                      regular: "",
                                                      "hide-details": true,
                                                      outlined: "",
                                                      color: 
                                                    _ctx.priceTextColor_amountData(
                                                        _ctx.form.single_prices.prices,
                                                        true,
                                                    )
                                                ,
                                                      rules: [_ctx.form.allPricesValidated || ''],
                                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (
                                                    _ctx.onVatRateChange(
                                                        _ctx.form.single_prices.prices,
                                                        $event,
                                                    )
                                                )),
                                                      onMouseover: _cache[29] || (_cache[29] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.vatRate,
                                                        true,
                                                    )
                                                )),
                                                      onMouseout: _cache[30] || (_cache[30] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.single_prices.prices.vatRate,
                                                        false,
                                                    )
                                                )),
                                                      "model-value": 
                                                    _ctx.form.single_prices.prices.vatType
                                                        ? _ctx.form.single_prices.prices.vatRate.value.toString() +
                                                          _ctx.form.single_prices.prices.vatType
                                                        : _ctx.form.single_prices.prices.vatRate.value.toString()
                                                ,
                                                      density: "compact"
                                                    }, null, 8, ["items", "color", "rules", "model-value"]), [
                                                      [_vShow, !_ctx.multiVat]
                                                    ])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "pa-0"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (!_ctx.multiVat)
                                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                                          key: 0,
                                                          color: "blue",
                                                          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.toggleLink(_ctx.form.single_prices.prices)))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.form.single_prices.prices.link
                                                        ? "$link"
                                                        : "$link_off"), 1)
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_ctx.multiVat)
                                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.form.subAmounts, (subAmount, index) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    style: {"display":"flex"},
                                                    key: index
                                                  }, [
                                                    _createVNode(_component_v_flex, {
                                                      xs3: "",
                                                      class: "pa-0"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_oss_text_field, {
                                                          regular: "",
                                                          dense: "",
                                                          "hide-details": true,
                                                          outlined: "",
                                                          "onUpdate:modelValue": [($event: any) => (
                                                        _ctx.onMetadataChange_amountData(
                                                            subAmount,
                                                            'netAmount',
                                                        )
                                                    ), ($event: any) => ((subAmount.netAmount.value) = $event)],
                                                          onMouseover: ($event: any) => (
                                                        _ctx.highlightField(subAmount.netAmount, true)
                                                    ),
                                                          onMouseout: ($event: any) => (
                                                        _ctx.highlightField(subAmount.netAmount, false)
                                                    ),
                                                          color: 
                                                        _ctx.priceTextColor_amountData(subAmount, false)
                                                    ,
                                                          rules: [
                                                        _ctx.areRowPricesValidated_amountData(
                                                            _ctx.form.single_prices.prices,
                                                            true,
                                                        ) || '',
                                                    ],
                                                          modelValue: subAmount.netAmount.value
                                                        }, {
                                                          label: _withCtx(() => [
                                                            _createTextVNode(" HT " + _toDisplayString(index + 1), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onUpdate:modelValue", "onMouseover", "onMouseout", "color", "rules", "modelValue"])
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_flex, {
                                                      xs3: "",
                                                      class: "pa-0"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_oss_text_field, {
                                                          regular: "",
                                                          dense: "",
                                                          "hide-details": true,
                                                          outlined: "",
                                                          "onUpdate:modelValue": [($event: any) => (
                                                        _ctx.onMetadataChange_amountData(
                                                            subAmount,
                                                            'grossAmount',
                                                        )
                                                    ), ($event: any) => ((subAmount.grossAmount.value) = $event)],
                                                          onMouseover: ($event: any) => (
                                                        _ctx.highlightField(subAmount.grossAmount, true)
                                                    ),
                                                          onMouseout: ($event: any) => (
                                                        _ctx.highlightField(subAmount.grossAmount, false)
                                                    ),
                                                          color: 
                                                        _ctx.priceTextColor_amountData(subAmount, false)
                                                    ,
                                                          rules: [
                                                        _ctx.areRowPricesValidated_amountData(
                                                            _ctx.form.single_prices.prices,
                                                            true,
                                                        ) || '',
                                                    ],
                                                          modelValue: subAmount.grossAmount.value
                                                        }, {
                                                          label: _withCtx(() => [
                                                            _createTextVNode(" TTC " + _toDisplayString(index + 1), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onUpdate:modelValue", "onMouseover", "onMouseout", "color", "rules", "modelValue"])
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_flex, {
                                                      xs3: "",
                                                      class: "pa-0"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_oss_text_field, {
                                                          regular: "",
                                                          dense: "",
                                                          "hide-details": true,
                                                          outlined: "",
                                                          "onUpdate:modelValue": [($event: any) => (
                                                        _ctx.onMetadataChange_amountData(
                                                            subAmount,
                                                            'vatAmount',
                                                        )
                                                    ), ($event: any) => ((subAmount.vatAmount.value) = $event)],
                                                          onMouseover: ($event: any) => (
                                                        _ctx.highlightField(subAmount.vatAmount, true)
                                                    ),
                                                          onMouseout: ($event: any) => (
                                                        _ctx.highlightField(subAmount.vatAmount, false)
                                                    ),
                                                          color: 
                                                        _ctx.priceTextColor_amountData(subAmount, false)
                                                    ,
                                                          rules: [
                                                        _ctx.areRowPricesValidated_amountData(
                                                            _ctx.form.single_prices.prices,
                                                            true,
                                                        ) || '',
                                                    ],
                                                          modelValue: subAmount.vatAmount.value
                                                        }, {
                                                          label: _withCtx(() => [
                                                            _createTextVNode(" TVA " + _toDisplayString(index + 1), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onUpdate:modelValue", "onMouseover", "onMouseout", "color", "rules", "modelValue"])
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_flex, {
                                                      xs2: "",
                                                      class: "pa-0"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_select_filled, {
                                                          items: 
                                                        subAmount.sign === -1
                                                            ? _ctx.vatListDiscount
                                                            : _ctx.vatList
                                                    ,
                                                          regular: "",
                                                          "hide-details": true,
                                                          outlined: "",
                                                          color: 
                                                        _ctx.priceTextColor_amountData(subAmount, false)
                                                    ,
                                                          rules: [
                                                        _ctx.areRowPricesValidated_amountData(
                                                            _ctx.form.single_prices.prices,
                                                            true,
                                                        ) || '',
                                                    ],
                                                          "onUpdate:modelValue": ($event: any) => (
                                                        _ctx.onVatRateChange(subAmount, $event)
                                                    ),
                                                          onMouseover: ($event: any) => (
                                                        _ctx.highlightField(subAmount.vatRate, true)
                                                    ),
                                                          onMouseout: ($event: any) => (
                                                        _ctx.highlightField(subAmount.vatRate, false)
                                                    ),
                                                          "model-value": 
                                                        subAmount.vatType
                                                            ? subAmount.vatRate.value.toString() +
                                                              subAmount.vatType
                                                            : subAmount.vatRate.value.toString()
                                                    ,
                                                          density: "compact"
                                                        }, null, 8, ["items", "color", "rules", "onUpdate:modelValue", "onMouseover", "onMouseout", "model-value"])
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_flex, {
                                                      xs1: "",
                                                      class: "pa-0"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_2, [
                                                          (_ctx.multiVat)
                                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                key: 0,
                                                                color: "blue",
                                                                onClick: ($event: any) => (_ctx.toggleLink(subAmount))
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(subAmount.link ? "$link" : "$link_off"), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"]))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]))
                                                }), 128))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_flex, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_oss_text_field, {
                                              "onUpdate:modelValue": [
                                                _cache[32] || (_cache[32] = ($event: any) => (
                                            _ctx.onMetadataChange(
                                                _ctx.form.single_prices.prices,
                                                '',
                                                'grossAmount',
                                            )
                                        )),
                                                _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.single_prices.prices.grossAmount.value) = $event))
                                              ],
                                              onMouseover: _cache[33] || (_cache[33] = ($event: any) => (
                                            _ctx.highlightField(
                                                _ctx.form.single_prices.prices.grossAmount,
                                                true,
                                            )
                                        )),
                                              onMouseout: _cache[34] || (_cache[34] = ($event: any) => (
                                            _ctx.highlightField(
                                                _ctx.form.single_prices.prices.grossAmount,
                                                false,
                                            )
                                        )),
                                              color: 
                                            _ctx.form.single_prices.prices.grossAmount.validated
                                                ? 'green'
                                                : 'red'
                                        ,
                                              success: _ctx.form.single_prices.prices.grossAmount.validated,
                                              error: !_ctx.form.single_prices.prices.grossAmount.validated,
                                              rules: [
                                            _ctx.form.single_prices.prices.grossAmount.validated || '',
                                        ],
                                              regular: "",
                                              "content-class": "mr-1 oss-",
                                              "hide-details": true,
                                              "append-outer-icon": 
                                            _ctx.form.single_prices.prices.grossAmount.validated
                                                ? '$check_box'
                                                : '$check_box_outline_blank'
                                        ,
                                              "onClick:appendOuter": _cache[35] || (_cache[35] = ($event: any) => (
                                            _ctx.form.single_prices.prices.grossAmount.validated =
                                                !_ctx.form.single_prices.prices.grossAmount.validated
                                        )),
                                              modelValue: _ctx.form.single_prices.prices.grossAmount.value
                                            }, {
                                              label: _withCtx(() => [
                                                _cache[63] || (_cache[63] = _createTextVNode(" TTC ")),
                                                (
                                                    _ctx.confidence(
                                                        _ctx.form.single_prices.prices.grossAmount,
                                                    )
                                                )
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                                      _cache[61] || (_cache[61] = _createTextVNode(" ( ")),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(
                                                        _ctx.confidence(
                                                            _ctx.form.single_prices.prices.grossAmount,
                                                        ) > 80
                                                            ? 'text-green'
                                                            : 'text-red'
                                                    )
                                                      }, _toDisplayString(`${_ctx.confidence(
                                                            _ctx.form.single_prices.prices.grossAmount,
                                                        )}%`), 3),
                                                      _cache[62] || (_cache[62] = _createTextVNode(") "))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }, 8, ["color", "success", "error", "rules", "append-outer-icon", "modelValue"])
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 7 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "py-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_radio_group, {
                                  label: "Type de TVA",
                                  modelValue: _ctx.document.vatType,
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.document.vatType) = $event)),
                                  rules: [!!_ctx.document.vatType || 'Type de VAT requise'],
                                  inline: "",
                                  required: "",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.document.type !== 'SALES_INVOICE')
                                      ? (_openBlock(), _createBlock(_component_v_radio, {
                                          key: 0,
                                          label: "Aucun",
                                          value: "NO_VAT_TYPE"
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_radio, {
                                      label: "Intracom",
                                      value: "INTRACOM",
                                      color: "secondary"
                                    }),
                                    (_ctx.document.type === 'SALES_INVOICE')
                                      ? (_openBlock(), _createBlock(_component_v_radio, {
                                          key: 1,
                                          label: "Export",
                                          value: "EXPORT"
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_radio, {
                                          key: 2,
                                          label: "Import",
                                          value: "IMPORT",
                                          color: "secondary"
                                        })),
                                    _createVNode(_component_v_radio, {
                                      label: "Autoliquidation",
                                      value: "REVERSE_CHARGE",
                                      color: "secondary"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "rules"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_v_btn, {
                      elevation: "0",
                      outlined: "",
                      rounded: "",
                      onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.previousStep())),
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[64] || (_cache[64] = [
                        _createTextVNode(" Précédent ")
                      ])),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.wizardStep > 1]
                    ]),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      rounded: "",
                      depressed: "",
                      onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.nextStep())),
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[65] || (_cache[65] = [
                        _createTextVNode(" Je valide ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, {
          "fill-height": "",
          value: 1
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_layout, { wrap: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_flex, {
                  xs12: "",
                  sm7: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_ctx.document)
                          ? (_openBlock(), _createElementBlock("svg", {
                              key: 0,
                              id: "svg-document-validation-mobile",
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "100%",
                              viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                              style: {"position":"absolute","width":"100%","left":"0","top":"0"},
                              class: "elevation-2"
                            }, [
                              _createElementVNode("image", {
                                id: "svg-image-document-validation-mobile",
                                "xlink:href": _ctx.document.signedUrl,
                                x: "0",
                                y: "0",
                                height: `${_ctx.imageHeight}px`,
                                width: `${_ctx.imageWidth}px`
                              }, null, 8, _hoisted_7)
                            ], 8, _hoisted_6))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.spreadPurchaseDialog,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.spreadPurchaseDialog) = $event)),
      title: "Etaler le montant sur plusieurs mois",
      onValid: _ctx.spreadAmount,
      validLoading: _ctx.loading,
      validDisabled: !_ctx.spreadValid,
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          modelValue: _ctx.spreadValid,
          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.spreadValid) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_layout, {
              wrap: "",
              xs12: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_flex, { xs12: "" }, {
                  default: _withCtx(() => _cache[66] || (_cache[66] = [
                    _createTextVNode(" Pour les charges supérieures à 1000 euros vous pouvez répartir le montant sur plusieurs mois ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_flex, { xs12: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_switch, {
                      modelValue: _ctx.activateSpreadAmount,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.activateSpreadAmount) = $event)),
                      label: "Etaler"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_v_flex, { xs12: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_date_picker, {
                      label: _ctx.$t('shared.spreadStartDate'),
                      modelValue: _ctx.spreadStartDate,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.spreadStartDate) = $event)),
                      minDate: _ctx.spreadMinStartDate,
                      maxDate: _ctx.spreadMaxStartDate,
                      type: 'month',
                      format: 'MM/YYYY'
                    }, null, 8, ["label", "modelValue", "minDate", "maxDate"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.activateSpreadAmount]
                ]),
                _withDirectives(_createVNode(_component_v_flex, {
                  xs12: "",
                  "mt-4": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_slider, {
                      modelValue: _ctx.spreadMounthCount,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.spreadMounthCount) = $event)),
                      "thumb-size": 24,
                      "thumb-label": "always",
                      label: "Nombre de mois",
                      min: "2",
                      max: "12",
                      color: "secondary",
                      "show-ticks": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.activateSpreadAmount]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading", "validDisabled"]),
    (_ctx.form.date)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          ref: "dateDialog",
          modelValue: _ctx.dateDialog,
          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.dateDialog) = $event)),
          "return-value": _ctx.form.date.value,
          "onUpdate:returnValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.form.date.value) = $event)),
          persistent: "",
          "without-title": "",
          width: "290px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_date_picker_wrapper, {
              modelValue: _ctx.form.date.value,
              "onUpdate:modelValue": [
                _cache[49] || (_cache[49] = ($event: any) => ((_ctx.form.date.value) = $event)),
                _cache[50] || (_cache[50] = ($event: any) => (_ctx.onDateChangeFromDatePicker()))
              ],
              "hide-header": "",
              scrollable: "",
              color: "secondary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.dateDialog = false)),
                  variant: "text"
                }, {
                  default: _withCtx(() => _cache[67] || (_cache[67] = [
                    _createTextVNode("Cancel")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.$refs.dateDialog.save(_ctx.form.date.value))),
                  variant: "text"
                }, {
                  default: _withCtx(() => _cache[68] || (_cache[68] = [
                    _createTextVNode("OK")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue", "return-value"]))
      : _createCommentVNode("", true),
    (_ctx.openChat)
      ? (_openBlock(), _createBlock(_component_Chat, {
          key: 1,
          id: _ctx.document.chat ? _ctx.document.chat.id : '',
          inShowMessage: _ctx.open_chat,
          chatTitle: 'Document',
          chatSubtitle: _ctx.getChatSubTitle(),
          showSmartChat: _ctx.wishStatus !== 'DENIED',
          onMessageSent: _cache[53] || (_cache[53] = ($event: any) => (_ctx.onMessageSent($event))),
          onShowMessageChanged: _cache[54] || (_cache[54] = ($event: any) => (_ctx.onShowMessageChanged($event)))
        }, null, 8, ["id", "inShowMessage", "chatSubtitle", "showSmartChat"]))
      : _createCommentVNode("", true),
    (_ctx.dialogSelectCompany)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 2,
          modelValue: _ctx.dialogSelectCompany,
          "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.dialogSelectCompany) = $event)),
          title: 'Choisir une société',
          width: "1000px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_company_table, {
              showGenericCompany: _ctx.document.type !== 'SALES_INVOICE',
              showSupplierCompanies: _ctx.document.type !== 'SALES_INVOICE',
              showConsumerCompanies: _ctx.document.type === 'SALES_INVOICE',
              showCustomerCompanies: _ctx.document.type === 'SALES_INVOICE',
              showExistingCompanies: false,
              company: _ctx.document.thirdPartyCompany ? _ctx.document.thirdPartyCompany.name : '',
              siret: 
                    _ctx.document.thirdPartyCompany && _ctx.document.thirdPartyCompany.siret
                        ? _ctx.document.thirdPartyCompany.siret
                        : ''
                ,
              siren: 
                    _ctx.document.thirdPartyCompany && _ctx.document.thirdPartyCompany.siren
                        ? _ctx.document.thirdPartyCompany.siren
                        : ''
                ,
              vatNumber: 
                    _ctx.document.thirdPartyCompany && _ctx.document.thirdPartyCompany.vatNumber
                        ? _ctx.document.thirdPartyCompany.vatNumber
                        : ''
                ,
              parentCompanyId: _ctx.selectedCompany.id,
              onSelectCompany: _ctx.companySelected
            }, null, 8, ["showGenericCompany", "showSupplierCompanies", "showConsumerCompanies", "showCustomerCompanies", "company", "siret", "siren", "vatNumber", "parentCompanyId", "onSelectCompany"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}